export const getAddRecordings = state => {
  return !! state.recordings.addRecording
};

export const isStreamOnly = state => {
  return !! state.recordings.streamOnly
};